import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { profile } from '../../data/site';
const ease = [0.22, 1, 0.36, 1] as const;
export function Hero() {
  return <section className="boardroom-light relative isolate overflow-hidden pt-32 pb-24 lg:pt-40 lg:pb-32" data-id="element-143" data-mp="jnf5sbwbiv2y">
      <div className="aurora" aria-hidden="true" data-id="element-144" data-mp="eo2ixr5g5o0d" />
      <div className="pattern-lattice-dark absolute inset-0 opacity-60" aria-hidden="true" data-id="element-145" data-mp="aotnmhurdi2p" />

      <div className="relative mx-auto grid max-w-7xl items-center gap-16 px-6 lg:grid-cols-[1.08fr_0.92fr] lg:px-10" data-id="element-146" data-mp="5p7bkbqo27vh">
        <div data-id="element-147" data-mp="r5h6unsim4p">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          ease
        }} className="flex items-center gap-3" data-id="element-148" data-mp="qvyzt8zlj9k">
            <span className="hairline-prism h-px w-14" aria-hidden="true" data-id="element-149" data-mp="1v2apwddqhoqw" />
            <p className="eyebrow text-gold-light" data-id="element-150" data-mp="1q5tr8p8wrrzk">Executive Legal Leadership</p>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.08,
          ease
        }} className="text-prism mt-7 font-display text-[2.75rem] font-light leading-[1.05] tracking-tight sm:text-6xl lg:text-[4.25rem]" data-id="element-151" data-mp="1murjwtiake63">
            {profile.name}
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.16,
          ease
        }} className="mt-6 flex flex-wrap items-center gap-x-3 gap-y-2 text-sm font-light tracking-wide text-slate-100 sm:text-base" data-id="element-152" data-mp="25nvdkevier0p">
            {profile.titles.map((title, index) => <React.Fragment key={title} data-id="element-153" data-mp="2oly97cikbm7h" data-mpi={index}>
                {index > 0 ? <span className="text-teal" data-id="element-154" data-mp="2okddhjkihx81">|</span> : null}
                <span data-id="element-155" data-mp="2tcodemf95j0l">{title}</span>
              </React.Fragment>)}
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.24,
          ease
        }} className="mt-8 max-w-xl text-base leading-relaxed text-slate-300/90" data-id="element-156" data-mp="338n5l5hipj9n">
            {profile.subheadline}
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.32,
          ease
        }} className="mt-11 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-157" data-mp="2p7u7kas0c61s">
            <a href="#about" className="btn-lux group inline-flex items-center justify-center gap-2 bg-violet px-8 py-4 text-[0.7rem] font-medium uppercase tracking-micro text-white shadow-jewel transition-colors duration-300 hover:text-navy" data-id="element-158" data-mp="2ajg6a4a8opnc">
              View Executive Profile
              <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" data-id="element-159" data-mp="1wkzqlnuefot2" />
            </a>
            <a href="#experience" className="btn-lux inline-flex items-center justify-center border border-teal/60 px-8 py-4 text-[0.7rem] font-medium uppercase tracking-micro text-white transition-colors duration-300 hover:text-navy" data-id="element-160" data-mp="c1nx5szppgap">
              Career Highlights
            </a>
            <Link to="/contact" className="inline-flex items-center justify-center px-2 py-4 text-[0.7rem] font-medium uppercase tracking-micro text-gold transition-colors duration-300 hover:text-gold-light" data-id="element-161" data-mp="pzceiqukm5b0">
              Connect
            </Link>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.15,
        ease
      }} className="relative mx-auto w-full max-w-md lg:max-w-none" data-id="element-162" data-mp="73covmp2fdul">
          <div className="relative overflow-hidden rounded-[1.75rem]" data-id="element-163" data-mp="3aq34178dobkw">
            <img src={profile.backdrop} alt="" aria-hidden="true" className="h-[30rem] w-full object-cover sm:h-[34rem]" loading="eager" data-id="element-164" data-mp="2ro2q1dsc1eap" />
            <div className="absolute inset-0" style={{
            background: 'linear-gradient(160deg, rgba(7,26,47,0.55), rgba(109,40,217,0.35) 45%, rgba(7,26,47,0.85))'
          }} aria-hidden="true" data-id="element-165" data-mp="31ef72w0xupc3" />
            <div className="pointer-events-none absolute inset-0 rounded-[1.75rem] ring-1 ring-inset ring-white/15" data-id="element-166" data-mp="35e661n0mcbrp" />

            <div className="absolute inset-0 flex items-center justify-center p-8" data-id="element-167" data-mp="3k9vvjv50j716">
              <motion.figure initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.9,
              delay: 0.4,
              ease
            }} className="glass-dark w-full max-w-[15rem] rounded-2xl p-3 text-center shadow-glass" data-id="element-168" data-mp="3fdevq3ogb489">
                <img src={profile.portrait} alt="Portrait of Jessica L. Cumbee" className="portrait-crisp h-56 w-full rounded-xl object-cover object-top" loading="eager" data-id="element-169" data-mp="hljbdfykhr2" />
                <figcaption className="px-2 pb-1 pt-4" data-id="element-170" data-mp="3rupnefmk6y7q">
                  <p className="font-display text-base font-normal text-white" data-id="element-171" data-mp="3rt4usvjt1pci">{profile.name}</p>
                  <p className="mt-1 text-[0.65rem] uppercase tracking-[0.18em] text-gold-light" data-id="element-172" data-mp="3dy2s0ha98g3x">
                    Chief Legal Officer
                  </p>
                </figcaption>
              </motion.figure>
            </div>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6,
          ease
        }} className="glass-dark absolute -bottom-6 left-6 right-6 rounded-xl px-6 py-4 sm:left-auto sm:-right-6 sm:w-64" data-id="element-173" data-mp="38xohmsl6ku2q">
            <p className="eyebrow text-teal" data-id="element-174" data-mp="15ouuz6delioc">Based in</p>
            <p className="mt-1.5 text-sm text-white" data-id="element-175" data-mp="10p077boxd97i">{profile.location}</p>
            <p className="mt-0.5 text-xs text-slate-400" data-id="element-176" data-mp="10r35sk458anu">Public &amp; private company governance</p>
          </motion.div>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 0.8
    }} className="relative mx-auto mt-20 max-w-7xl px-6 lg:px-10" data-id="element-177" data-mp="qrlwlsponen4">
        <div className="hairline-prism h-px w-full" aria-hidden="true" data-id="element-178" data-mp="1jgj9fgb4kj8h" />
        <p className="mt-6 text-center text-[0.7rem] uppercase leading-relaxed tracking-[0.16em] text-slate-400" data-id="element-179" data-mp="1eo9j3z63lh5o">
          {profile.positioning}
        </p>
      </motion.div>
    </section>;
}